import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '../components/login/service/login.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(LoginService);
  const router = inject(Router);

  const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';

  if (authService.isAuthorizedUser && isLoggedIn) {
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
};